import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sanitize'
})
export class SanitizePipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return '';
    }
    // Use a regular expression to remove HTML tags
    return value.replace(/<[^>]*>/g, '');
  }

}



// WEBPACK FOOTER //
// ./src/pipes/sanitize/sanitize.ts